import { useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useAuth } from '@/core/auth';
import { LoadingSpinner } from '@/shared/components/ui';

import { createRoutes } from './routes';

export function AppRouter() {
  const auth = useAuth();

  // Memoize the router to prevent recreation on every render
  // Only recreate when user changes (login/logout/group change)
  const router = useMemo(() => {
    if (!auth.initialized) return null;

    return createBrowserRouter(createRoutes(auth.user), {
      basename: import.meta.env.VITE_APP_ROUTER_BASE || undefined,
    });
  }, [auth.initialized, auth.user]);

  if (!auth.initialized || !router) {
    return <LoadingSpinner fullScreen />;
  }

  return <RouterProvider router={router} />;
}

export * from './navigation-routes';
